import { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

type LogBitbucketAnalyticsOptions = {
  readonly createAnalyticsEvent: CreateUIAnalyticsEvent;
  readonly analytics: BitbucketAnalyticsArgs;
  readonly eventType?: string;
};

type BitbucketAnalyticsArgs = {
  readonly event: string;
  readonly attributes?: { [key: string]: any };
  readonly eventType: string;
  readonly action: string;
};

export const BITBUCKET_ANALYTICS_EVENTS = {
  ORG_CREATE: 'orgCreate',
  ORG_CREATE_STATUS: 'orgCreateStatus',
  ORG_FETCH: 'getAccountOrgs',
  WORKSPACE_PROVISION: 'activateProductBitbucket'
};

export const BITBUCKET_EVENT_NAMES = {
  VIEWED: 'viewed',
  CLICKED: 'clicked',
  ERROR: 'errored',
  SUCCESS: 'succeeded'
};

export function logBitbucketAnalytics({
  createAnalyticsEvent,
  analytics,
  eventType = 'operational'
}: LogBitbucketAnalyticsOptions): void {
  const analyticsEvent = createAnalyticsEvent({
    eventComponent: 'signUpBitbucketCMT',
    actionSubject: 'signupForm',
    source: 'bitbucketWacSignupPage',
    ...analytics
  });

  // manually adjust the analytics context to use operational event type if it exists
  if (analyticsEvent.context && analyticsEvent.context.length > 0) {
    analyticsEvent.context[0].eventType = eventType;
  }

  analyticsEvent.fire();
}

type BitbucketProvFailAnalytics = {
  readonly createAnalyticsEvent: CreateUIAnalyticsEvent;
  readonly metadata?: { [key: string]: any };
};

export async function trackBitbucketWorkspaceProvFailure({
  createAnalyticsEvent,
  metadata
}: BitbucketProvFailAnalytics): Promise<void> {
  logBitbucketAnalytics({
    createAnalyticsEvent,
    analytics: {
      event: `${BITBUCKET_ANALYTICS_EVENTS.WORKSPACE_PROVISION} provisioned`,
      eventType: 'operational',
      action: 'errored',
      attributes: metadata
    }
  });
}
